import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { getMockApplicantListings } from '../../../../RentalPortalApplicant'
import { InputAsyncSelect, InputSelectControl } from '../../../../Select'
import {
  QA_NAME_VIEWING_FORM_LISTING,
  VIEWING_FORM_FIELD_NAME,
} from '../../RentalPortalViewingFormModal.constants'
import { getToViewingFormListingItems } from '../../RentalPortalViewingFormModal.utils'

import RentalPortalIcon from '../../../../../icons/rental-portal.svg'

function ViewingFormListingField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Control={InputSelectControl}
      EntityIcon={RentalPortalIcon}
      Select={InputAsyncSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('RentalPortal.ApplicantFormListingPlaceholderKey'),
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('RentalPortal.ViewingListingColumnKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getData={getMockApplicantListings}
      getDataItems={getItemsFromIdwellApiResponse}
      getErrorProps={getFormikFormFieldErrorProps}
      name={VIEWING_FORM_FIELD_NAME.listing}
      qaName={QA_NAME_VIEWING_FORM_LISTING}
      toPreparedItems={getToViewingFormListingItems(t)}
    />
  )
}

export default ViewingFormListingField
